import { days } from "../constants/date";

const DateService = {
  parse(date: string | number | Date) {
    return new Date(date);
  },
  toMonthDateYearString(date: Date): string {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  },
  toMonthDateYearTimeEstString(date: Date): string {
    let hour = date.getHours();
    let isAm = hour < 11;

    if (hour === 0) {
      hour = 12;
    } else if (hour > 12) {
      hour -= 12;
    }

    let minutes = date.getMinutes();

    return `${days[date.getDay()]}, ${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()} ${hour}:${
      minutes < 10 ? "0" + minutes : minutes
    }${isAm ? "am" : "pm"} EST`;
  },
};

export default DateService;
